<template>
  <div>
    <div class="table dataTable users-table">
      <sort-fields :headings="headings" :users="users" @sortChanged="sortChanged" />
      <div class="users-cards">
        <users-table-row v-for="user in users.data"
                         :user="user"
                         :isManager="isManager"
                         :needUnavailabilityDatesProviderId="needUnavailabilityDatesProviderId"
                         :entityId="entityId"
                         :key="user.id">
        </users-table-row>
      </div>
    </div>
    <div v-show="users.data.length == 0" class="no-users-data">{{ $t('messages.no_data') }}</div>


  <div class="users-pagination">
    <paginate
      :page-count="totalPage[users.state]"
      :margin-pages="2"
      v-model="pageNumber"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :hide-prev-next="true"
      :prev-text="$t('pagination.previous')"
      :next-text="$t('pagination.next')"
      />
  </div>
  </div>
</template>

<script>
  import Paginate from 'vuejs-paginate'
  import SortFields from '@/components/common/SortFields'
  import UsersTableRow from './UsersTableRow'
  import { mapGetters } from 'vuex'

  export default {
    name: 'UsersTable',
    props: ['users', 'isManager', 'entityId', 'entities'],
    components: {
      Paginate,
      UsersTableRow,
      SortFields,
    },
    data: function() {
      return {
        pageNumber: 1
      }
    },
    methods: {
      fetchUsersByPage(pageNum) {
        this.$store.dispatch('users/searchWithPaginate', { currentPage: pageNum,
                                                           userState: this.users.state,
                                                           entityId: this.entityId })
      },
      sortChanged(sortField, sortOrder) {
        this.$emit("sortChanged", sortField, sortOrder)
      }
    },
    computed: {
      ...mapGetters({
        perPage: 'users/perPage',
        totalPage: 'users/totalPage',
        currentPage: 'users/currentPage',
        currentUser: 'auth/currentUser'
      }),
      headings() {
        return (this.isManager ? this.tableManagerHeadings : this.tableHeadings)
      },
      tableHeadings() {
        var headings = [
          {'key': 'last_name', 'value': this.$i18n.t('table.headers.name')},
          {'key': 'email', 'value': this.$i18n.t('table.headers.coordinates')},
          {'key': 'resource_type', 'value': this.$i18n.t('table.headers.internal')},
          {'key': 'services.name', 'value': this.$i18n.t('table.headers.affiliation_service')},
        ]

        if (this.needUnavailabilityDatesProviderId) {
          headings.splice(5, 0, {'key': 'provider_id', 'value': this.$i18n.t('table.headers.provider_id')})
        }
        return headings;
      },
      tableManagerHeadings() {
        return [
          {'key': 'last_name', 'value': this.$i18n.t('table.headers.name')},
          {'key': 'email', 'value': this.$i18n.t('table.headers.coordinates')},
        ]
      },
      currentEntity() {
        return this.entities ? this.entities.find(entity => entity.id == this.entityId) : null
      },
      needUnavailabilityDatesProviderId(){
        if (this.currentUser == null || this.currentEntity == null) {
            return false;
        }
        if (!this.currentUser.entities) {
          return false;
        }
        return this.currentEntity.unavailability_dates_provider
      }
    },
    watch: {
      pageNumber() {
        this.fetchUsersByPage(this.pageNumber)
      },
      currentPage() {
        this.pageNumber = this.currentPage[this.users.state]
      }
    },
    mounted() {
      this.pageNumber = this.currentPage[this.users.state]
    },
    updated() {
      const $lastCard = $('.card').last();
      $('.dropdown').removeClass('dropup');
      $('.dropdown', $lastCard).addClass('dropup');
    }
  }
</script>

<style scoped>
  .users-pagination {
    padding: 15px;
  }
  .table {
    border-collapse: separate;
    border-spacing: 0 2px;
  }
  .table tbody tr td {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .no-users-data {
    text-align: center;
  }
  @media (max-width: 767px) {
    .users-table {
      width: 98%;
      max-width: 98%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/users/UsersTable.vue